'use client';

import { queryString } from '@preventx/prismic-services';

// Types
import {
  GetRequest,
  GetResponse,
  PostRequest,
  PostResponse,
} from '@/types/api/siteSearch';
import { SearchResponse } from '@/types/siteSearch/search';

const buildBaseUrl = (path: string) =>
  `${location.origin}/api/site-search/${path}`;

export const get = async ({ payload }: GetRequest): Promise<GetResponse> => {
  const endpoint = queryString(buildBaseUrl('search'), payload);
  const encodedEndpoint = encodeURI(endpoint);

  const response = await fetch(encodedEndpoint, { method: 'GET' });

  return {
    statusCode: response.status,
    data: response.ok ? ((await response.json()) as SearchResponse) : undefined,
  };
};

export const post = async ({ payload }: PostRequest): Promise<PostResponse> => {
  const response = await fetch(buildBaseUrl('event'), {
    method: 'POST',
    body: JSON.stringify(payload),
  });

  return { statusCode: response.status };
};
